import React from 'react'

import { CircularProgress, Grid, Stack, Toolbar, Typography, styled } from '@mui/material'

const StyledToolbar = styled(Toolbar)`
    padding-left: 16px;
    padding-right: 12px;
`

const StyledTypography = styled(Typography)`
    // margin-top: 0.4rem;
    margin-bottom: 0.4rem;
`

const ToolbarActions = styled('div')`
    display: flex;
    align-items: center;
`

const ToolbarTitle = styled('div')`
    flex-grow: 1;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
`

interface Props {
    title?: string | null | React.ReactElement
    subtitle?: string
    children?: React.ReactNode
    loading?: boolean
}

export const ToolbarWithButtons: React.FC<Props> = ({ title, subtitle, children, loading }: Props) => {
    const TITLE_MAX_LENGTH = 25
    const flexRows = typeof title === 'string' && title?.length >= TITLE_MAX_LENGTH
    return (
        <StyledToolbar>
            <Grid item container direction="row" justifyContent="flex-start" alignItems="center" xs={12} spacing={1}>
                <Grid item container direction="row" xs={flexRows ? 12 : 6} sm={5}>
                    <ToolbarTitle>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography variant="h6">{title}</Typography>
                            {loading && <CircularProgress size={16} />}
                        </Stack>
                        {subtitle && <StyledTypography variant="body1">{subtitle}</StyledTypography>}
                    </ToolbarTitle>
                </Grid>
                <Grid item container direction="row" xs={flexRows ? 12 : 6} sm={7} justifyContent="flex-end">
                    <ToolbarActions>{children}</ToolbarActions>
                </Grid>
            </Grid>
        </StyledToolbar>
    )
}
